module.exports = __webpack_public_path__ + "img/zhiwu3.6a120c85.jpg";